import { api } from "@/client/api"

export default {
    loadApplyTestCase(id) {
        return api.post(`/test-cases/apply/${encodeURIComponent(id)}`)
    }
}
